import React, {Component} from 'react';

import Button from 'base/components/Button';
import Toolbar from 'base/components/common/Toolbar';
// import API from 'base/api'

const AdminIndex = () => (
  <div>
    <Toolbar title="Panel admina" titleUrl="/admin"/>
    <div className="container">
      <div className="admin-buttons-wrapper">
        <Button url="/admin/event">Zarządzaj wydarzeniem</Button>
        <Button url="/admin/list">Lista studentów</Button>
        <Button url="/admin/rooms">Pokoje</Button>
        <Button url="/admin/excel">Dodaj excela</Button>
      </div>
    </div>
  </div>
);

export default AdminIndex;


// WEBPACK FOOTER //
// ./src/modules/Admin/views/AdminIndex.js